"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardShopPresentation = CardShopPresentation;
const react_1 = __importDefault(require("react"));
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const ui_1 = require("@creature-chess/ui");
const CoinIcon_1 = require("~/components/ui/icon/CoinIcon");
const sessionContext_1 = require("~/game/sessionContext");
const plugins_1 = require("~/plugins");
const useStyles_1 = require("~/useStyles");
const BalanceIcon_1 = require("../../../ui/icon/BalanceIcon");
const card_1 = require("./card");
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    shop: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        boxSizing: "border-box",
    },
    cards: {
        display: "flex",
        flexDirection: "column",
        padding: "2%",
        background: "#404040",
        height: "100%",
        justifyContent: "space-between",
    },
    bottomBar: {
        "display": "flex",
        "flexDirection": "row",
        "justifyContent": "space-between",
        "padding": "2%",
        "background": "#303030",
        "gap": "16px",
        "& > button": {
            flex: 1,
        },
    },
    balance: {
        "flex": 1,
        "display": "flex",
        "justifyContent": "center",
        "alignItems": "center",
        "color": "#ffffff",
        "fontSize": "32px",
        "letterSpacing": "3px",
        "@media (orientation: portrait) and (max-width: 400px)": {
            fontSize: "18px",
        },
    },
    balanceIcon: {
        marginRight: "8px",
    },
    control: {
        "border": "none",
        "cursor": "pointer",
        "background": "#38b764",
        "color": "#101010",
        "borderRadius": "4px",
        "fontFamily": theme.typography.primary,
        "fontOpticalSizing": "auto",
        "fontWeight": 700,
        "fontStyle": "normal",
        "fontSize": "24px",
        "padding": "4% 6%",
        "&[disabled]": {
            background: "#303030",
            cursor: "not-allowed",
        },
        "&:hover": {
            background: "#4aeb82",
        },
        "transition": "background 0.2s ease-in-out",
        "& > span": {
            fontSize: "14px",
            marginLeft: "6px",
        },
        "@media (orientation: portrait) and (max-width: 376px)": {
            "fontSize": "16px",
            "& > span": {
                fontSize: "10px",
            },
        },
    },
}));
function CardShopPresentation({ cards, money, ownedDefinitionIds, onReroll, onToggleLock, onBuy, isLocked, }) {
    const classes = useStyles();
    const { rerollCost } = (0, sessionContext_1.useGamemodeSettings)();
    return (react_1.default.createElement("div", { className: classes.shop },
        react_1.default.createElement("div", { className: classes.cards }, cards.map((card, index) => (react_1.default.createElement(plugins_1.Region, { key: index, cls: "card-shop-card", id: `shop.card.${index}`, ctx: { cardIndex: index, card } }, card !== null && (react_1.default.createElement(card_1.Card2D, { card: card, money: money, owned: ownedDefinitionIds.includes(card.definitionId), onBuy: () => onBuy === null || onBuy === void 0 ? void 0 : onBuy(index) })))))),
        react_1.default.createElement("div", { className: classes.bottomBar },
            react_1.default.createElement("div", { className: classes.balance },
                react_1.default.createElement(BalanceIcon_1.BalanceIcon, { className: classes.balanceIcon, amount: money })),
            react_1.default.createElement("div", null,
                react_1.default.createElement(ui_1.Button, { color: "secondary", size: "medium", onClick: onToggleLock }, isLocked ? (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faLockOpen })) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faLock }),
                    "\u00A0",
                    react_1.default.createElement("span", null, "(1 turn)"))))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(ui_1.Button, { color: "secondary", size: "medium", onClick: onReroll, disabled: money < rerollCost },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faArrowsRotate }),
                    "\u00A0",
                    react_1.default.createElement("span", null,
                        rerollCost,
                        " ",
                        react_1.default.createElement(CoinIcon_1.CoinIcon, null)))))));
}
